import { render, staticRenderFns } from "./platapply-approval.vue?vue&type=template&id=4654a9d7&"
import script from "./platapply-approval.vue?vue&type=script&lang=js&"
export * from "./platapply-approval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports